
























































































































































import CustomFieldListForm from "@/components/report/CustomFieldListForm.vue";
import ProjectCreateDialog from "@/components/ticket/project/ProjectCreateDialog.vue";
import SelectUpdateTags from "@/components/tag/SelectUpdateTags.vue";
import Debug from "@/components/utility/Debug.vue";
import HasDescription from "@/components/utility/HasDescription.vue";
import RefsProject from "@/components/utility/RefsProject.vue";
import RefsTicket from "@/components/utility/RefsTicket.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { IAction, IChips } from "@/components/utility/mmmint/MHeader.vue";
import { getFlagEmoji, getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";
import { TicketStatusEnum } from "@/lib/enum/ticket-status.enum";
import { emailRule, phoneRuleOptional } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import { TicketGoToHelper } from "@/lib/utility/ticket.go-to-helper";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Address } from "@/models/address.entity";
import { CustomFieldValue } from "@/models/custom-field-value.entity";
import { IPageFilterElement, PageFilterElement } from "@/models/page-filter-element.entity";
import { IProject, Project } from "@/models/project.entity";
import { ITicket, Ticket } from "@/models/ticket.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { ConfigModule } from "@/store/modules/config";
import { ContractClientModule, ContractProviderModule } from "@/store/modules/contract.store";
import { FleetAggregationModule, IRefSuggestion } from "@/store/modules/fleet-aggregation.store";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { ProjectModule } from "@/store/modules/project.store";
import { TicketModule } from "@/store/modules/ticket.store";
import { debounce } from "debounce";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import ContractSelectByClientOrProviderUpdateDialog from "../contract/ContractSelectByClientOrProviderUpdateDialog.vue";
import ContractTable from "../contract/ContractTable.vue";
import CostCreateDialog from "../cost/CostCreateDialog.vue";
import PartnerHasPartnerBankingIdsTable from "../partner-banking/PartnerHasPartnerBankingIdsTable.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import CopyClipboardText from "../utility/CopyClipboardText.vue";
import RefsSelect from "../utility/RefsSelect.vue";
import MActionList from "../utility/mmmint/MActionList.vue";
import MDetailViewGrid from "../utility/mmmint/MDetailViewGrid.vue";
import MHeaderEditTitle from "../utility/mmmint/MHeaderEditTitle.vue";
import TicketSideCardActivities from "./TicketSideCardActivities.vue";

@Component({
  components: {
    TicketSideCardActivities,
    HasDescription,
    MHeaderEditTitle,
    MDetailViewGrid,
    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    RefsProject,
    RefsTicket,
    CustomFieldListForm,
    MActionList,
    ConfirmActionDialog,
    ProjectCreateDialog,
    Debug,
    CopyClipboardText,
    RefsSelect,
    ContractSelectByClientOrProviderUpdateDialog,
    ContractTable,
    PartnerHasPartnerBankingIdsTable,
    SelectAssignees,
    SelectUpdateTags,
    CostCreateDialog
  },
  filters: {
    getFlagEmojiByLanguage,
    getFlagEmoji
  }
})
export default class TicketDetail extends mixins(PartnerFallbackMixin, PermissionMixin) {
  readonly Ticket = Ticket;
  readonly Address = Address;
  readonly CountryCodeEnum = CountryCodeEnum;
  readonly ResourceEnum = ResourceEnum;
  readonly formable = Ticket;
  readonly ContractProviderModule = ContractProviderModule;
  readonly ContractClientModule = ContractClientModule;

  @Prop()
  value!: ITicket;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  @Ref("editTitleHeader")
  editTitleHeader!: MHeaderEditTitle;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  project: IProject | null = null;

  isLoadingProject = false;

  isLoadingProjects = false;

  isLoadingCustomFieldValues = false;

  isLoadingRefs = false;

  isLoadingDueDate = false;

  isLoadingAssignees = false;

  isLoadingStatus = false;

  isCostCreateDialogActive = false;

  isLoadingAssigneesUpdate = false;

  isLoadingAssigneesAdded = false;

  isLoadingAssigneesRemoved = false;

  get refs() {
    return [
      {
        refType: BackendResourceEnum.TICKET,
        refId: this.value.id
      },
      ...(this.value.refs ?? [])
    ];
  }

  get suggested(): IRefSuggestion[] {
    return FleetAggregationModule.referenceSuggestions;
  }

  get descriptionProp(): keyof Pick<ITicket, "body"> {
    return "body";
  }

  get contractClientTableFilters(): IPageFilterElement[] {
    return [
      new PageFilterElement({
        key: "clientIds.refId",
        operation: PageFilterOperationEnum.EQUAL,
        value: this.value.id
      })
    ];
  }

  get contractProviderTableFilters(): IPageFilterElement[] {
    return [
      new PageFilterElement({
        key: "providerIds.refId",
        operation: PageFilterOperationEnum.EQUAL,
        value: this.value.id
      })
    ];
  }

  get refsCategories(): BackendResourceEnum[] {
    const categories: BackendResourceEnum[] = [];

    if (this.canReadReport) {
      categories.push(BackendResourceEnum.REPORT);
    }
    if (this.canReadVehicle) {
      categories.push(BackendResourceEnum.VEHICLE);
    }
    if (this.canReadEvent) {
      categories.push(BackendResourceEnum.EVENT);
    }
    if (this.canReadAppraisal) {
      categories.push(BackendResourceEnum.APPRAISAL);
    }
    if (this.canReadRepairEstimate) {
      categories.push(BackendResourceEnum.REPAIR_ESTIMATE);
    }
    if (this.canReadRental) {
      categories.push(BackendResourceEnum.RENTAL);
    }

    return categories;
  }

  get availableLanguages() {
    return ConfigModule.availableLanguages;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get emailRule() {
    return [requiredRule(), emailRule()];
  }

  get phoneRule() {
    return [phoneRuleOptional()];
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const breadCrumbs = TicketGoToHelper.breadCrumbs;

    const selected = [];

    selected.push(breadCrumbs.TicketTable(this.value.partnerId));
    selected.push(breadCrumbs.TicketDetail(this.value.partnerId, this.value.id));

    return selected;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new TicketGoToHelper(this.$router).goToTicketDetail({
            partnerId: this.value.partnerId,
            ticketId: this.value.id,
            newTab: false
          })
      });
    }

    if (this.can(ActionEnum.UPDATE, ResourceEnum.TICKET)) {
      actions.push({
        text: $t("project.ticket.editTitle"),
        key: "title",
        icon: "mdi-pencil",
        color: "",
        exec: () => this.editTitleHeader.startEditingTitle()
      });
    }

    if (this.can(ActionEnum.CREATE, ResourceEnum.COST)) {
      actions.push({
        key: "money",
        icon: "mdi-cash-multiple",
        text: $t("cost.createCost"),
        color: "",
        exec: () => (this.$refs.costCreateDialog as CostCreateDialog).show()
      });
    }

    return actions;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      text: $t("enums.TicketStatusEnum." + this.value.state),
      key: "state",
      color: TicketModule.ticketStateMap.get(this.value.state as TicketStatusEnum)?.color || "grey"
    });

    if (this.value.isOverdue) {
      chips.push({
        text: $t("project.ticket.overdue"),
        key: "overdue",
        color: "error",
        icon: "mdi-calendar"
      });
    }

    return chips;
  }

  get bottomActions() {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new TicketGoToHelper(this.$router).goToTicketDetail({
            partnerId: this.value.partnerId,
            ticketId: this.value.id,
            newTab: false
          })
      });
    }

    const projectId = this.value.projectId;
    if (projectId) {
      actions.push({
        text: $t("project.ticket.actions.viewInProject"),
        key: "toProject",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new TicketGoToHelper(this.$router).goToProjectCustomView({
            partnerId: this.value.partnerId,
            projectId: projectId,
            viewId: "0",
            newTab: false
          })
      });
    }

    actions.push({
      key: "cope",
      icon: "mdi-content-copy",
      text: $t("project.ticket.actions.copyLink"),
      color: "",
      exec: () => {
        const baseUrl = window.location.origin;
        const route = TicketGoToHelper.locations.ticketDetail({
          partnerId: this.value.partnerId,
          ticketId: this.value.id
        });
        const url = this.$router.resolve(route).href;
        navigator.clipboard.writeText(`${baseUrl}/${url}`);
      }
    });

    if (this.value.state === TicketStatusEnum.DRAFT || this.value.state === TicketStatusEnum.CLOSED) {
      actions.push({
        key: "state",
        icon: "mdi-file-edit-outline",
        text: $t("project.ticket.actions.openTask"),
        color: "",
        loading: this.isLoadingStatus,
        exec: () => this.updateTicketStatus(TicketStatusEnum.OPEN)
      });
    }
    if (this.value.state === TicketStatusEnum.OPEN) {
      actions.push({
        key: "state",
        icon: "mdi-file-edit-outline",
        text: $t("project.ticket.actions.markDraft"),
        color: "",
        loading: this.isLoadingStatus,
        exec: () => this.updateTicketStatus(TicketStatusEnum.DRAFT)
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.TICKET)) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get projects() {
    return ProjectModule.entities;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.TICKET
    };
  }

  debounceSaveCustomFields = debounce(this.saveCustomFieldValues, 1000);

  async beforeMount() {
    await this.updateSuggestions();
  }

  async updateSuggestions() {
    this.isLoadingRefs = true;
    try {
      await FleetAggregationModule.updateSuggestions({
        selected: this.value.refs ?? [],
        month: new Date().getMonth(),
        year: new Date().getFullYear()
      });
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingRefs = false;
    }
  }

  mounted() {
    this.setProject();
  }

  onDeleteItem() {
    this.isDeleteDialogActive = true;
  }

  getUserNameForId(id: string) {
    const user = PartnerUserModule.maps.id.get(id)[0];

    let name = "";
    if (user) {
      name = `${user.firstName} ${user.lastName}`;
    }

    return name;
  }

  async changeDueDate(due: string) {
    this.isLoadingDueDate = true;
    try {
      await this.value.updatePartial({
        due: due
      });
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingDueDate = false;
    }
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;

      await this.value.delete();

      this.$toast.success("👍");

      this.isDeleteDialogActive = false;

      this.$emit("deleted");
    } catch (e) {
      handleError(e);
    } finally {
      this.isDeleteLoading = false;
    }
  }

  goToProjectCustomView() {
    if (!this.value.projectId) return;

    new TicketGoToHelper(this.$router).goToProjectCustomView({
      partnerId: this.value.partnerId,
      projectId: this.value.projectId,
      viewId: "0",
      newTab: false
    });
  }

  @Watch("value.projectId")
  async setProject() {
    this.project = null;

    const projectId = this.value.projectId;
    if (projectId) {
      this.isLoadingProject = true;
      this.isLoadingCustomFieldValues = true;

      const project =
        ProjectModule.maps.id.get(projectId)[0] ||
        (await new Project({ partnerId: this.partner.id, id: projectId }).fetch().catch(handleError));
      this.isLoadingProject = false;
      this.isLoadingCustomFieldValues = false;

      this.$nextTick(() => {
        this.project = project;
      });
    }
  }

  async saveRefs() {
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  async saveGroup() {
    this.isLoadingProject = true;
    await this.value
      .updatePartial({
        projectId: this.value.projectId
      })
      .catch(handleError);
    this.isLoadingProject = false;
  }

  async saveCustomFieldValues() {
    this.isLoadingCustomFieldValues = true;
    await this.value
      .updatePartial({
        values: CustomFieldValue.buildCustomFieldValuesDto(
          this.value.values.map(v => ({ id: v.id, value: v.value, timezone: v.timezone }))
        )
      })
      .catch(handleError);
    this.isLoadingCustomFieldValues = false;
  }

  async refreshProjects() {
    this.isLoadingProjects = true;
    try {
      ProjectModule.setFilters([
        new PageFilterElement({
          key: "type",
          operation: PageFilterOperationEnum.EQUAL,
          value: ResourceEnum.TICKET
        })
      ]);
      await ProjectModule.fetchAll({ partnerId: PartnerModule.partner.id });
    } catch (e) {
      handleError(e);
    }
    this.isLoadingProjects = false;
  }

  openAddReference() {
    (this.$refs.refsSelect as RefsSelect)?.open();
  }

  async onAssigneesUpdate(assignees: []) {
    if (!this.can(ActionEnum.UPDATE, ResourceEnum.TICKET)) return;
    this.isLoadingAssigneesUpdate = true;
    await this.value.updatePartial({ assignees });
    this.isLoadingAssigneesUpdate = false;
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.can(ActionEnum.UPDATE, ResourceEnum.TICKET)) return;
    this.isLoadingAssigneesAdded = true;
    await this.value.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
    this.isLoadingAssigneesAdded = false;
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.can(ActionEnum.UPDATE, ResourceEnum.TICKET)) return;
    this.isLoadingAssigneesRemoved = true;
    await this.value.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
    this.isLoadingAssigneesRemoved = false;
  }

  async updateTicketStatus(status: TicketStatusEnum) {
    this.isLoadingStatus = true;

    try {
      await this.value.updateState(status).catch(handleError);
    } catch (e) {
      handleError(e);
    }
    this.isLoadingStatus = false;
  }
}
